// extracted by mini-css-extract-plugin
export default {"successModal":"SuccessfulPaymentModal_successModal__xefu5","successModalContent":"SuccessfulPaymentModal_successModalContent__kV9bo"};